/**
 * ProgressDiaryPage — a hand-curated journal of progress notes.
 *
 * Per user iter 68: a free-form diary in homepage typography (Times
 * New Roman throughout).  Each entry has a precise timestamp + body.
 * Entries are defined here as data so adding the next one is a
 * single-array push.
 */
import TopBar from "@/components/TopBar";
import NavPane from "@/components/NavPane";
import DOMPurify from "dompurify";

// Per code-review: bodyHtml is hand-authored in this file (no external
// input) but we still run it through DOMPurify before injection so the
// XSS-by-dangerouslySetInnerHTML lint warning is satisfied and any
// future entry pasted from a third-party source is sanitised.
const SANITIZE_CFG = {
  ALLOWED_TAGS: ["p", "br", "ol", "ul", "li", "table", "thead", "tbody", "tr", "th", "td", "em", "strong", "i", "b", "span", "a", "blockquote"],
  ALLOWED_ATTR: ["style", "href", "target", "rel"],
};

const PAL = {
  bg: "#0F0E0C",
  ink: "#F5F1E8",
  muted: "#9C8E72",
  accent: "#E5C870",
  panel: "rgba(20,18,15,0.72)",
  border: "rgba(229,200,112,0.18)",
};
const TIMES = "'Times New Roman',Times,serif";

const ENTRIES = [
  // Per user iter 69: newest entries first, top-down.
  {
    dateLabel: "June 5, 2026, 1:43am PT",
    bodyHtml:
      "Which part of &lsquo;Don&rsquo;t recommend channel&rsquo; and " +
      "&lsquo;Not interested&rsquo; doesn&rsquo;t YouTube&rsquo;s " +
      "algorithm understand?  I keep getting the same type of crap from " +
      "other channels.  God knows I&rsquo;m not a fan of &lsquo;Breaking " +
      "Bad&rsquo;, but nowadays would watch it only if I was hammered.  " +
      "Is that what YouTube is counting on?  " +
      "I&rsquo;m trying to recondition my brain!",
  },
  {
    dateLabel: "June 4, 2026, 1:01am PT",
    bodyHtml:
      "Looks like I&rsquo;m going to have to see a doctor &mdash; and a " +
      "damn good one &mdash; to get an actual diagnosis on whether I " +
      "actually have ADHD.",
  },
  {
    dateLabel: "May 31, 2026, 11:48pm PT",
    bodyHtml:
      "ChatGPT: What you&rsquo;re seeing is probably not alpha " +
      "transparency at all." +
      "<br/><br/>" +
      "Historically, MS Paint did not support alpha channels.  " +
      "Instead, it had a concept called a transparent selection, " +
      "where one color in the image (often white) was treated as " +
      "&lsquo;don&rsquo;t copy this color&rsquo; during certain " +
      "operations." +
      "<br/><br/>" +
      "For example:" +
      "<ol style=\"margin-top:0.4em;margin-bottom:0;padding-left:1.6em;list-style:decimal;\">" +
      "<li>Draw a black shape on a white background.</li>" +
      "<li>Use Select.</li>" +
      "<li>Enable Transparent selection.</li>" +
      "<li>Move or paste the selection elsewhere.</li>" +
      "</ol>" +
      "<br/>" +
      "The white pixels are not actually transparent in the file.  " +
      "They&rsquo;re still ordinary white pixels.  Paint is simply " +
      "ignoring that color while performing the selection operation." +
      "<br/><br/>" +
      "So there are two completely different mechanisms:" +
      "<table style=\"margin-top:0.6em;margin-bottom:0.2em;border-collapse:collapse;width:100%;max-width:760px;\">" +
      "<thead><tr>" +
      "<th style=\"text-align:left;padding:0.35em 0.6em;border-bottom:1px solid rgba(229,200,112,0.35);\">Mechanism</th>" +
      "<th style=\"text-align:left;padding:0.35em 0.6em;border-bottom:1px solid rgba(229,200,112,0.35);\">Stored in file?</th>" +
      "<th style=\"text-align:left;padding:0.35em 0.6em;border-bottom:1px solid rgba(229,200,112,0.35);\">White pixels preserved?</th>" +
      "</tr></thead>" +
      "<tbody>" +
      "<tr>" +
      "<td style=\"padding:0.35em 0.6em;vertical-align:top;border-bottom:1px solid rgba(229,200,112,0.12);\">Alpha transparency (PNG)</td>" +
      "<td style=\"padding:0.35em 0.6em;vertical-align:top;border-bottom:1px solid rgba(229,200,112,0.12);\">Yes</td>" +
      "<td style=\"padding:0.35em 0.6em;vertical-align:top;border-bottom:1px solid rgba(229,200,112,0.12);\">Can be transparent regardless of color</td>" +
      "</tr>" +
      "<tr>" +
      "<td style=\"padding:0.35em 0.6em;vertical-align:top;\">Transparent selection (Paint)</td>" +
      "<td style=\"padding:0.35em 0.6em;vertical-align:top;\">No</td>" +
      "<td style=\"padding:0.35em 0.6em;vertical-align:top;\">White color is treated as background during selection</td>" +
      "</tr>" +
      "</tbody></table>" +
      "<br/>" +
      "That&rsquo;s why a BMP created in Paint can sometimes behave as " +
      "though the white background is transparent even though BMP " +
      "files traditionally don&rsquo;t contain an alpha channel." +
      "<br/><br/>" +
      "If your goal is &lsquo;easy selection in Paint,&rsquo; sometimes " +
      "a solid white background is actually better than real " +
      "transparency because Paint&rsquo;s transparent-selection " +
      "feature can use that white as the background color to ignore.  " +
      "Real alpha transparency and Paint&rsquo;s transparent-selection " +
      "behavior do not always interact the way you might expect.",
  },
  {
    dateLabel: "May 31, 2026, 11:46pm PT",
    bodyHtml:
      "I want to create a doorway into a world where I want to live.  " +
      "That&rsquo;s why I&rsquo;m thinking of giving up on " +
      "&lsquo;Angus&rsquo; and choosing to begin work on " +
      "&lsquo;A People&rsquo;s Chant&rsquo;.",
  },
  {
    dateLabel: "May 28, 2026, 8:09am PT",
    bodyHtml:
      "I asked ChatGPT: Is it ok to leave unfinished something that " +
      "you&rsquo;ve started in the past?  Or is that a bad habit?" +
      "<br/><br/>" +
      "ChatGPT: Leaving something unfinished is not automatically a bad " +
      "habit.  It depends on why you stopped and whether the pattern is " +
      "helping or hurting your life." +
      "<br/><br/>" +
      "There are at least four very different situations:" +
      "<ol style=\"margin-top:0.4em;margin-bottom:0;padding-left:1.6em;list-style:decimal;\">" +
      "<li><em>You learned enough and moved on.</em>  This is normal.  " +
      "Many projects, hobbies, books, games, and ideas are exploratory.  " +
      "Stopping can be rational.</li>" +
      "<li><em>The goal stopped matching your priorities.</em>  People " +
      "change.  Continuing solely because you already invested time is " +
      "often the &lsquo;sunk cost fallacy.&rsquo;</li>" +
      "<li><em>You consistently abandon things the moment they become " +
      "difficult.</em>  That can become a harmful habit because it " +
      "prevents skill development and long-term progress.</li>" +
      "<li><em>You intentionally pause something to return later.</em>  " +
      "This is common in creative, technical, and research work.  Many " +
      "engineers, artists, and writers cycle between projects.</li>" +
      "</ol>" +
      "<br/>" +
      "A useful question is not &ldquo;Did I finish?&rdquo; but: " +
      "&ldquo;Did stopping improve or worsen my long-term direction?&rdquo;" +
      "<br/><br/>" +
      "For example, in software, hardware, art, music, game development, " +
      "and research, unfinished experiments are extremely common.  Many " +
      "successful people have folders full of abandoned prototypes." +
      "<br/><br/>" +
      "On the other hand, if every meaningful effort gets dropped before " +
      "completion, then it may be worth building a habit of finishing " +
      "smaller scoped projects first.",
  },
  {
    dateLabel: "May 25, 2026, 9:57am PT",
    bodyHtml:
      "I completely forgot about playtesting and relapsed to trying to " +
      "finish &lsquo;Angus&rsquo; as well as growing ideas for yet another " +
      "game &mdash; more like a clone than an all-original IP.  I think " +
      "I&rsquo;m going to call it &lsquo;A People&rsquo;s Chant&rsquo;; " +
      "it&rsquo;s going to be a clone of &lsquo;The Settlers&rsquo; " +
      "(I actually used to play a lot of &lsquo;Knights and Merchants&rsquo;) " +
      "and it&rsquo;s going to be a low-res game for the full screen " +
      "(in my case 1920x1080) and it will be a multi-player game.  " +
      "I&rsquo;ll have to work out the main menu, the music, maybe the " +
      "soundbites, the details for how to store player data, etc.  " +
      "It&rsquo;s going to have some Early, High, and Late Middle Ages " +
      "and Renaissance vibes.",
  },
  {
    dateLabel: "May 17, 2026, 9:34pm PT",
    bodyHtml:
      "&ldquo;If a company stops maintaining a video game and abandons support of it, " +
      "can it be uploaded somewhere on the internet and then downloaded for free?" +
      "<br/><br/>" +
      "Usually no &mdash; a company stopping updates, servers, or customer support " +
      "for a video game does not automatically make it free to upload, share, or " +
      "download." +
      "<br/><br/>" +
      "In most countries (including the U.S.), the game is still protected by " +
      "copyright unless one of these happens:" +
      "<ul style=\"margin-top:0.4em;margin-bottom:0;padding-left:1.6em;list-style:disc;\">" +
      "<li>the rights holder explicitly releases it as freeware/open source,</li>" +
      "<li>the copyright expires (typically many decades),</li>" +
      "<li>or you have permission/license from the rights holder.</li>" +
      "</ul>" +
      "<br/>" +
      "&lsquo;Abandonware&rsquo; is a common term for unsupported old software, " +
      "but it&rsquo;s not a legal status under U.S. copyright law, and hosting or " +
      "distributing it without permission is generally still infringement." +
      "<br/><br/>" +
      "So: unsupported &ne; public domain.  A dead game can still legally belong " +
      "to someone &mdash; sometimes the original studio, sometimes a publisher, " +
      "sometimes whoever acquired the IP.&rdquo;",
  },
  {
    dateLabel: "May 17, 2026, 2:05pm PT",
    bodyHtml:
      "(The following content in double quotation marks is the output of " +
      "Emergent, the AI agent building this website.)" +
      "<br/><br/>" +
      "&ldquo;Found two distinct things:" +
      "<br/><br/>" +
      "<b>&#10004; Preview is correct.</b>  The new Diablo II entry with " +
      "&lsquo;Ctrl + Shift + Esc&rsquo; + Report ID is present (rendered " +
      "in the API response just above).  The font revert, knock-on-chess/" +
      "checkers, etc. all live in the same preview build." +
      "<br/><br/>" +
      "<b>&#128680; Production (andrewgreen.gg) is currently returning " +
      "HTTP 502 Bad Gateway from nginx.</b>  That&rsquo;s why your changes " +
      "don&rsquo;t appear &mdash; the latest deployment is not serving " +
      "traffic.  This isn&rsquo;t a code issue I can fix from here; it&rsquo;s " +
      "an infrastructure / deployment-status issue on the Emergent " +
      "platform." +
      "<br/><br/>" +
      "<b>What to do:</b>" +
      "<ol style=\"margin-top:0.4em;margin-bottom:0;padding-left:1.6em;list-style:decimal;\">" +
      "<li>Wait 2&ndash;3 more minutes and refresh &mdash; if the deploy " +
      "is still finalising, the 502 will clear once the new container " +
      "becomes ready.</li>" +
      "<li>If it persists past 15 minutes total, email " +
      "<i>support@emergent.sh</i> with:" +
      "<ul style=\"margin-top:0.3em;padding-left:1.4em;list-style:disc;\">" +
      "<li>The URL: <i>https://andrewgreen.gg</i></li>" +
      "<li>The endpoint returning 502: <i>/api/logs/playtest</i></li>" +
      "<li>The deploy/job ID from your Emergent dashboard</li>" +
      "<li>A screenshot of the deployment status panel</li>" +
      "</ul></li>" +
      "</ol>" +
      "<br/>" +
      "Once production comes back up, the Diablo II entry, the timer font " +
      "revert, and the rest will all appear automatically &mdash; they&rsquo;re " +
      "already in the deployed build&rsquo;s source." +
      "<br/><br/>" +
      "Want me to keep refreshing the production endpoint and tell you the " +
      "moment it goes green?&rdquo;" +
      "<br/><br/>" +
      "Interesting.",
  },
  {
    dateLabel: "May 16, 2026, 2:09pm PT",
    bodyHtml:
      "Per the entry made on May 16, 2026, 1:30am PT: I was being very serious " +
      "about that entry.  I can&rsquo;t shake the thought of the opportunity I " +
      "am being given here &mdash; as a programmer! (though they haven&rsquo;t " +
      "even answered my question regarding what kinds of programmers they are " +
      "looking for), &mdash; but I also can&rsquo;t shake the thought of the " +
      "concept &mdash; a 4-player horror/survival co-op?!  &hellip;  Who wants " +
      "to work on a cookie-cutter concept?  I&rsquo;ve seen people play games " +
      "like these and I felt absolutely nothing.  Nothing from the music, " +
      "nothing from the sound design, nothing from the tone of the visuals, " +
      "no taste in menus.  The best I&rsquo;ve seen of something in a similar " +
      "vein was <i>Amnesia: The Dark Descent</i> (not a co-op, but that&rsquo;s " +
      "not the point) but I checked out after two hours.  This is not my idea " +
      "of an addictive, escapist experience.  This is just not my kind of genre.",
  },
  {
    dateLabel: "May 16, 2026, 1:30am PT",
    bodyHtml:
      "I was just offered work as a programmer on a &lsquo;4-player co-op horror&rsquo; " +
      "[game] and I must admit I have a bad feeling about this.  How do I know this " +
      "is not a shovelware demo?  Are we really just churning out generic disposable " +
      "content to impress people?  This is how we stand out?  Is the programmer just " +
      "a cog in a machine of something that does not want to make something " +
      "memorable?",
  },
  {
    dateLabel: "May 12, 2026, 2:48am PT",
    bodyHtml:
      "Ran into a pickle: I lifted some nature sounds from Apple Music, and apparently " +
      "these are so well recognized by SoundCloud that the platform figured them to be " +
      "copyrighted.  Guess I&rsquo;ll just have to record something as non-descript as a " +
      "whipping wind all by myself before I blend it with the sound of wolves.  No more " +
      "lifting from Apple Music.  Maybe I&rsquo;ll just have to lift from YouTube because " +
      "I don&rsquo;t know of any wolves here in the Bay Area.  The same goes for my blend " +
      "of crashing waves, seagull keowing, and the sound of a ship&rsquo;s bell.  Ouch.",
  },
  {
    dateLabel: "May 12, 2026, 12:36am PT",
    bodyHtml:
      "Things to do on the docket (in this order):" +
      "<ol style=\"margin-top:0.6em;margin-bottom:0;padding-left:1.6em;list-style:decimal;\">" +
      "<li>Upload the design doc and the flowchart for <i>Angus &hellip;</i> to the game&rsquo;s page.  " +
      "I&rsquo;m thinking about making it using Gamemaker, not Godot.  God forbid if I get tired of " +
      "making this game.</li>" +
      "<li>Update the game dev log on the website.</li>" +
      "<li>Buy a new domain for my website.</li>" +
      "<li>Upload on SoundCloud: music for Pente, howling/wind sounds, and &lsquo;naval&rsquo; sounds.</li>" +
      "<li>Check out the GameTester offer.</li>" +
      "<li>Report issues with <i>Diablo 2: Resurrected</i> on my rig.</li>" +
      "<li>Report issues with <i>WoW</i> on my rig.</li>" +
      "<li>Start taking playtesting gigs on UpWork.</li>" +
      "<li>Play <i>Disciples: Sacred Lands</i> online.</li>" +
      "<li>Connect with people on GDN (intro, etc.), other Discord servers.</li>" +
      "<li>Connect with communities on the <i>Heroes of Might and Magic</i> websites.</li>" +
      "<li>Reach out to the <i>Executors of Tribute</i> WoW guild on Discord.</li>" +
      "<li>Decide on what to make using Godot.  Not sure what, though.  Again, God forbid if I get " +
      "tired of making this game.</li>" +
      "</ol>",
  },
  {
    dateLabel: "May 11, 2026, 4:40pm PT",
    bodyHtml:
      "Yet another work week begins for me &mdash; more timesink as a manufacturing " +
      "technician just to make ends meet; therefore, not as much time to work on my " +
      "games as I&rsquo;d like.  The fact that I have to do some playtesting for " +
      "different titles across multiple platforms and the thought of having to " +
      "iterate on the games I&rsquo;ve made with Emergent over the past couple of " +
      "weeks just doesn&rsquo;t make me feel better about how I manage my time.  " +
      "Found some people to talk to on Discord, but I also want to find more people " +
      "in other places, like Steam and <i>Heroes of Might and Magic forums</i>.  " +
      "It&rsquo;s nice to have something like Emergent to help me get things done " +
      "fast for a website since I don&rsquo;t know much of JS and know none of " +
      "React, but now I need to challenge myself, re-learn using Gamemaker and " +
      "learn using Godot with the aid of ChatGPT.  Maybe I&rsquo;ll focus on making " +
      "one map, one hero, one building &mdash; &ldquo;one of everything&rdquo;, as " +
      "I like to call the concept for my demos.  I might make it look pixellated, " +
      "limit it to 256 colors, though perhaps something like Adventure Game Studio " +
      "is the best tool for something like this?  Who knows?" +
      "<br/><br/>" +
      "I so wish I had a playtesting job instead &hellip; even though I do hear " +
      "that it&rsquo;s all just grunt work.  But at least I would have a sense " +
      "like I&rsquo;m doing something valuable for myself even if the project is " +
      "crap.",
  },
  {
    dateLabel: "May 10, 2026, 10:44pm PT",
    bodyHtml:
      "Feeling burned out from printing, trimming, and putting up interactive canvas art " +
      "from my favorite games all over the kitchen features facing me in my microstudio " +
      "here in Oakland, CA.  Now I&rsquo;m just listening to music from my space-themed " +
      "Pente clone &mdash; all of which, including the music, was generated by Emergent " +
      "under my direction.  Next stop: either (a) joining a bunch of <i>Heroes of Might " +
      "and Magic</i> and <i>Disciples: Sacred Lands</i> webforums or (b) deploying this " +
      "website.",
  },
  {
    // Migrated from the homepage Announcements block on iter 69; the
    // git timestamp of the block's first commit was 2026-05-06
    // 23:52:50 UTC, which converts to May 6, 2026 4:52pm PT (PDT).
    dateLabel: "May 6, 2026, 4:52pm PT",
    bodyHtml:
      "I want to create another clone of Pong but it&rsquo;s going to be drug-themed.  The buffs and " +
      "debuffs are going to be drugs.  I may have to add a screen to that to notify the visitor that " +
      "they understand that the content is meant for people of age 18+.  After that I will focus on " +
      "directing Emergent to add certain board games and card games to the website.  I am still testing " +
      "my mettle as a UI and sprite artist.  If <i>Ricochet Xtreme</i> is a well-dressed " +
      "<i>Arkanoid</i> clone, how hard can it really be to dress a game like Pong?",
  },
];

export default function ProgressDiaryPage() {
  return (
    <div className="min-h-screen" style={{ background: PAL.bg, color: PAL.ink }} data-testid="progress-diary-page">
      <TopBar theme="studio" />
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row">
        <div className="md:w-[260px] md:shrink-0 md:min-h-screen flex flex-col pt-4 md:pt-6 px-4 md:px-6 pb-6 md:border-r" style={{ borderColor: PAL.border }}>
          <NavPane theme="studio" />
        </div>
        <main className="flex-1 flex flex-col pt-4 md:pt-6 px-6 md:px-12 pb-10">
          <div className="max-w-3xl">
            <h1
              className="leading-[1.02] mb-7"
              style={{
                fontFamily: TIMES,
                fontWeight: 500,
                color: PAL.accent,
                fontSize: "clamp(2.4rem, 5vw, 5rem)",
                letterSpacing: "0.005em",
                textShadow: "0 2px 0 rgba(0,0,0,0.55), 0 0 28px rgba(229,200,112,0.22)",
              }}
              data-testid="progress-diary-title"
            >
              The Journal
            </h1>

            <div className="flex flex-col gap-6" data-testid="progress-diary-entries">
              {ENTRIES.map((entry, i) => (
                <article
                  key={entry.dateLabel}
                  className="rounded-sm border p-6"
                  style={{ background: PAL.panel, borderColor: PAL.border, fontFamily: TIMES }}
                  data-testid={`progress-diary-entry-${i}`}
                >
                  <div
                    className="mb-3 text-sm"
                    style={{ color: PAL.accent, fontFamily: TIMES, letterSpacing: "0.04em" }}
                    data-testid={`progress-diary-entry-${i}-date`}
                  >
                    {entry.dateLabel}
                  </div>
                  <div
                    className="text-base"
                    style={{ color: "#D6CCB4", fontFamily: TIMES, lineHeight: 1.7, fontWeight: 400 }}
                    data-testid={`progress-diary-entry-${i}-body`}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(entry.bodyHtml, SANITIZE_CFG) }}
                  />
                </article>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
